import translate from "@/i18n/translate";
import { WmButton } from "@watermarkinsights/ripple-react";
import { ParticipationOverviewInterface } from "@/features/sll/Sll";
import { ReportingYear } from "@/features/common/interfaces/Interface";

interface ParticipationOverviewProps {
  participationOverview: ParticipationOverviewInterface | null;
  reportingYear: ReportingYear | null;
}

export function ParticipationOverview({
  participationOverview,
  reportingYear
}: ParticipationOverviewProps) {
  return (
    <>
      <div id="participation-overview">
        <div className="participation-section">
          <div className="participation-text">
            {translate("app.participationOverview.participationOverview")}
          </div>
          <div className="participation-overview-container">
            <div className="count">{participationOverview?.orgCount}</div>
            <div className="label">
              {translate("app.participationOverview.orgPrograms", {
                reportingYear: reportingYear?.name
              })}
            </div>
          </div>
          <div className="participation-overview-container">
            <div className="count">
              {participationOverview?.assessmentCount}
            </div>
            <div className="label">
              {translate("app.participationOverview.commonAssessments")}
            </div>
          </div>
          <div className="participation-overview-container">
            <div className="count">{participationOverview?.studentCount}</div>
            <div className="label">
              {translate("app.participationOverview.studentsAssessed")}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
